export interface StatusOption {
  value: string;
  name: string;
}


//Product List status
export const ProductStatus: StatusOption[] = [
  { value: "", name: "Select Status" },
  { value: "0", name: "Inactive" },
  { value: "1", name: "Active" },
];

//Order List status
export const OrderStatus: StatusOption[] = [
  { value: "", name: "Select Status" },
  { value: "Pending", name: "Pending" },
  { value: "Processing", name: "Processing" },
  { value: "Shipped", name: "Shipped" },
  { value: "Delivered", name: "Delivered" },
  { value: "Cancelled", name: "Cancelled" },
];

//Complaint List status
export const ComplaintStatus: StatusOption[] = [
  { value: "", name: "Select Status" },
  { value: "0", name: "Pending" },
  { value: "1", name: "Accepted" },
  { value: "2", name: "Rejected" },
  { value: "3", name: "Resolved" },
];

//Category Management List Status
export const CategoryStatus: StatusOption[] = [
  { value: "", name: "Select Status" },
  { value: "0", name: "Inactive" },
  { value: "1", name: "Active" },
]


//Offer Management List Status
export const OfferStatus: StatusOption[] = [
  { value: "", name: "Select Status" },
  { value: "0", name: "Inactive" },
  { value: "1", name: "Active" },
]